export { default } from './useMediaQuery';